import React from 'react'

const HeaderMiniso = () => {
  const logoMinisoURL ="https://minisolove.miniso.com.mx/logoMinisoNoBG.png"
  return (
    <div>
      <div className='d-flex justify-content-start bg-light align-items-center py-2'>
        <img style={{width:"50px"}} 
        src={logoMinisoURL} alt="Miniso" />
        <h6 className='fs-4'>
        PORTAL DE MONITOREO
        </h6>
      </div>
    </div>
  )
}

export default HeaderMiniso